import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
Role: string;
  constructor() { }

getRole() {
this.Role = localStorage.role;
return this.Role;
}

checkRoutes() {
  
  const userRole = this.getRole();
  let route = '';
  switch (userRole) {
                case 'MasterSystemAdministrator': route = '/dashboard/mastersystemadmin'; break;
                case 'SystemAdministrator': route = '/dashboard/systemadmin'; break;
                case 'ClientAdministrator': route = '/dashboard/clientadmin'; break;
                case 'RoleAdministrator': route = '/dashboard/roleadmin'; break;
                case 'Contact': route = '/dashboard/contact'; break;
                case 'DemoAdministrator': route = '/dashboard/demoadmin'; break;
                case 'DemoCandidate': route = '/dashboard/democandidate'; break;
                case 'Candidate': route = '/dashboard/candidate'; break;
            }
  return route;
}

getTabsForHeader() {
  const userRole = this.getRole();
  let tabs = {};
  switch (userRole) {
    case 'MasterSystemAdministrator':
    tabs = [
    {
      name: 'Settings',
      route: '/dashboard/mastersystemadmin/setting'
    }, {
      name: 'Candidate',
      route: '/dashboard/mastersystemadmin/candidate'
    },
     {
      name: 'Test Events',
      route: '/dashboard/mastersystemadmin/testevent'
    }]; break;

    case 'SystemAdministrator': tabs = [
      {
      name: 'Settings',
      route: '/dashboard/systemadmin/setting'
    }, {
      name: 'Candidate',
      route: '/dashboard/systemadmin/candidate'
    },
     {
      name: 'Test Events',
      route: '/dashboard/systemadmin/testevent'
    }];
                                break;

    case 'ClientAdministrator': tabs = [
    {
      name: 'Settings',
      route: '/dashboard/clientadmin/setting'
    }, {
      name: 'Candidate',
      route: '/dashboard/clientadmin/candidate'
    },
     {
      name: 'Test Events',
      route: '/dashboard/clientadmin/testevent'
    }];
                                break;

    case 'RoleAdministrator': tabs = [
    {
      name: 'Settings',
      route: '/dashboard/roleadmin/setting'
    }, {
      name: 'Candidate',
      route: '/dashboard/roleadmin/candidate'
    },
    {
      name: 'Test Events',
      route: '/dashboard/roleadmin/testevent'
    }];                       break;

    case 'Contact': tabs = [ {
      name: 'Candidate',
      route: '/dashboard/contact/candidate'
    }, {
      name: 'Test Events',
      route: '/dashboard/contact/testevent'
    }];             break;

    case 'DemoAdministrator': tabs =  [
      {
      name: 'Settings',
      route: '/dashboard/demoadmin/setting'
    }, {
      name: 'Candidate',
      route: '/dashboard/demoadmin/candidate'
    },
     {
      name: 'Test Events',
      route: '/dashboard/demoadmin/testevent'
    }];
                              break;

    case 'DemoCandidate': tabs = [];
                          break;

    case 'Candidate': tabs = [];
                      break;
}
  return tabs;
}

rankWiseRole(roles) {
  const roleList = [];
  const rank1 = roles.find((element) => {
    return element.name === 'MasterSystemAdministrator';
  });
  if (rank1) { roleList.push(rank1); }
  const rank2 = roles.find((element) => {
    return element.name === 'SystemAdministrator';
  });
  if (rank2) { roleList.push(rank2); }
  const rank3 = roles.find((element) => {
    return element.name === 'ClientAdministrator';
  });
  if (rank3) { roleList.push(rank3); }
  const rank4 = roles.find((element) => {
    return element.name === 'RoleAdministrator';
  });
  if (rank4) { roleList.push(rank4); }
  const rank5 = roles.find((element) => {
    return element.name === 'Contact';
  });
  if (rank5) { roleList.push(rank5); }
  const rank6 = roles.find((element) => {
    return element.name === 'DemoAdministrator';
  });
  if (rank6) { roleList.push(rank6); }
  const rank7 = roles.find((element) => {
    return element.name === 'DemoCandidate';
  });
  if (rank7) { roleList.push(rank7); }

  return roleList;
}
}
